import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleList } from "@fortawesome/pro-regular-svg-icons/faRectangleList";

export const defaultTranslations = {
    pluginName: "Info Panel",
    pluginDescription: "Add info panel",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faRectangleList} size="3x" />,
};
